import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { SketchDetails } from "../../../components/sketch_details/SketchDetails";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getContestDetailThunk as onGetContestDetailThunk } from "../../../slices/contest/thunk";
import { getContestCommentsThunk as onGetContestComments, saveContestCommentsThunk as onSaveContestComments } from "../../../slices/comments/thunk";
import { getAuthUser } from "../../../utils/GetAuthUser";
import { CountdownTimer } from "../../contest/CountdownTimer";
import ParticipateContest from "./ParticipateContest";
import { SketchResult } from "../../users/uploadimage/create_contest/SketchResult";
import { CommentCheck } from "../../../components/comment/CommentCheck";


const contestSelector = (state) => state.contest.contestList;

const selectCommentsState = (state) => state.comments;
const commentsSelector = createSelector(selectCommentsState, (comments) => ({
  comments: comments.comments,
  isLoading: comments.isLoading,
  isSaving: comments.isSaving,
  isCommentSave: comments.isCommentSave,
}));

export const ArtistContestDetail = () => {

  const dispatch = useDispatch();
  const { contestId } = useParams();

  const contestList = useSelector(contestSelector);
  const { comments, isLoading, isSaving, isCommentSave } = useSelector(commentsSelector);
  const authUser = getAuthUser();
  const currentArtistId = authUser?.user?.id;


  const [contestDetail, setContestDetail] = useState(null);
  const [showParticipateButton, setShowParticipateButton] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  
  const [sketchData, setSketchData] = useState({
    id: null,
    name: "",
    description: "",
    media: [],
    timeLeft: 0,
  });

  const [isPremiumUser,setIsPremiumUser]=useState(false);

  useEffect(() => {

    if (contestId) {
      dispatch(onGetContestDetailThunk({ contestId }));
      dispatch(onGetContestComments({ contest_id: contestId })).then((response) => {
     
      });
    }
  }, [dispatch, contestId]);

  useEffect(() => {
    if (!contestList || !contestList.id) return;

    const participants = contestList.participants || [];
    const isAlreadyParticipant = participants.some(
      (p) => p.artist_id == currentArtistId
    );

    setContestDetail(contestList);
    setShowCountdown(Boolean(contestList.timeLeft));
    setShowParticipateButton(!isAlreadyParticipant);

    setSketchData({
      id: contestList.id || null,
      name: contestList.contestCategory || "",
      description: contestList.contestDescription || "",
      media: contestList.contestMedia || [],
      timeLeft: contestList.timeLeft || 0,
    });

     if(contestList.isPremiumUser==1){
        setIsPremiumUser(true)
        }
  }, [contestList, currentArtistId]);

  // Refresh comments after saving a new comment
  useEffect(() => {
    if (isCommentSave) {
      dispatch(onGetContestComments({ contest_id: contestId }));
    }
  }, [isCommentSave, dispatch, contestId]);

  const handleSaveComment = (commentData) => {
    dispatch(onSaveContestComments(commentData));
  };

  if (!contestDetail) return null;

  const uploadedResults = contestDetail.uploadedResults || [];
  const uploadedResultForArtist = uploadedResults.find(
    (r) => r.artist_id == currentArtistId
  );


  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title="Contest" showBack={true} />
      </header>

      <div className="w-full bg-[#F7F7F7]">
        <div className="w-full mx-auto flex flex-col items-start justify-center gap-12 lg:flex-row mt-9">
          {/* Left Side */}
          <div className="w-full lg:w-[40%] flex">
            <SketchDetails
              name={sketchData.name}
              description={sketchData.description}
              sketchMedia={sketchData.media}
              isShowDetail={showParticipateButton ? 2 : 1}
               contestId={contestId}
             isResultUploads={contestDetail?.uploadedResults?.length > 0 ? 1 : 2}
             sketchData={sketchData}
             contestData={contestDetail}


            />
          </div>

          {/* Right Side */}
          <div className="w-full flex flex-col items-start justify-start lg:w-[60%]">
  
           {
            uploadedResultForArtist && uploadedResultForArtist.media ? (
              <SketchResult result={uploadedResultForArtist.media[0].file_name} />
            ) : 
            <>
            { showParticipateButton ? (
              <div className="w-full lg:w-full h-full flex items-start justify-center">
                <ParticipateContest
                    description={sketchData.description}
                    contestId={contestId}
                  />
              </div>
            ) : (
              showCountdown && (
                <div className="cursor-pointer w-full min-h-[584px] h-full flex flex-col items-center justify-center border-2 border-dashed border-border_color rounded-[14px]">

                    <CountdownTimer
                      timeLeft={contestDetail?.timeLeft}
                      contestId={contestId}
                    />
                </div>
              )
            )}
            </>
           }

            <div className="w-full bg-[#F7F7F7]">
              <div className="w-full flex flex-col items-center gap-12 lg:flex-row mt-9">
                {isPremiumUser && (
                  <CommentCheck 
                    contestId={contestId} 
                    comments={comments} 
                    isLoading={isLoading}
                    isSaving={isSaving}
                    onSaveComment={handleSaveComment}
                  />
                )}
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  );
};
